<template>
    <div :id="!!id ? id : 'modal'"
         class="modal fade"
         :data-bs-backdrop="!!backdropStatic ? 'static' : null"
         tabindex="-1"
         :aria-labelledby="!!id ? '#' . id : null"
         aria-hidden="true"
         :ref="!!id ? id : 'modal'">
        <div class="modal-dialog modal-dialog-centered" :class="!!size ? 'modal-' + size : 'modal-lg'">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        {{ title }}
                    </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            @click="closeModal"></button>
                </div>

                <div class="modal-body">
                    <slot></slot>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal" v-if="!!closeButtonText">
                        {{ closeButtonText }}
                    </button>

                    <button type="button" class="btn btn-primary" @click="acceptModal" v-if="!!acceptButtonText">
                        {{ acceptButtonText }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <v-modal :title="confirmModalTitle ?? 'Confirmar'"
             size="sm"
             :accept-button-text="confirmModalAcceptButtonText ?? 'Confirmar'"
             :close-button-text="confirmModalCloseButtonText ?? 'Cancelar'"
             :content="confirmModalText ?? '¿Estás seguro?'"
             v-if="show_confirm_modal"
             @accepted="acceptConfirmModal"
             @closed="closeConfirmModal">
        {{ confirmModalText }}
    </v-modal>
</template>

<script>
import {Modal} from "bootstrap";
import VModal from "./VModal";

export default {
    name: 'VModalConfirmed',
    components: {VModal},
    props: {
        id: {
            type: String,
            required: false,
            default: 'modal',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        closeButtonText: {
            type: String,
            required: false,
        },
        acceptButtonText: {
            type: String,
            required: false,
        },
        confirmModalTitle: {
            type: String,
            required: false,
        },
        confirmModalCloseButtonText: {
            type: String,
            required: false,
        },
        confirmModalAcceptButtonText: {
            type: String,
            required: false,
        },
        confirmModalText: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            required: false,
            default: 'lg'
            // TODO: Validator doesn't work, so I can't force it here
        }
    },
    data() {
        return {
            was_accepted: false,
            show_confirm_modal: false,
        }
    },
    mounted() {
        this.modal = new Modal(this.$refs.modal);
        this.modal.show();

        this.$refs.modal.addEventListener('hide.bs.modal', () => {
            if (this.was_accepted === true) {
                this.$emit('accepted');
            } else {
                this.$emit('closed');
            }
        })
    },
    methods: {
        acceptConfirmModal() {
            this.was_accepted = true;
            this.closeModal();
        },
        closeConfirmModal() {
            this.show_confirm_modal = false;
        },
        acceptModal() {
            this.show_confirm_modal = true;
        },
        closeModal() {
            this.modal.hide();
        }
    },

};
</script>
